<template lang="pug">
  .wrapper-user-list
    h2 usuários

    .editor(v-if="showHeader")
      UserDetails(:id="editingId", :employeeId="this.employeeId", @close="closeEdit" :key="editingId")

    label(v-if="!showHeader") total de usuários ativos: {{ totalUsers }}
    PSelect(
        v-model="mode"
        name="mode"
        labelItem="name"
        :allowEmpty="false"
        title="mostrar"
        @change="changeMode"
    )
    .buttons(v-if="!showHeader")
      PButton(color="primary" size="md" @click="genReport") planilha de usuários
      PButton(
        color="warning"
        size="md"
        @click="createNewUser"
        v-if="$hasPermission({module: 'user', action: 'post'})"
      ) criar novo usuário

    SmartTable.table(
      name="user-list"
      v-bind="table",
      v-model="tableData"
      :loadPageFunction="carregarPagina"
      @rowClick="onSelectedUser"
      ref="table"
    )
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")

          template(v-slot:roleGroup="{ columnValue, rowItem, index }")
            template(v-if="!reloadingUserInfo") {{ columnValue ? columnValue.name : '' }}
            .loading-field(v-else key="loading-roleGroup")

          template(v-slot:group="{ columnValue, rowItem, index }")
            template(v-if="!reloadingUserInfo && columnValue")
              span(v-if="columnValue.length > 1") vários
              span(v-else-if="columnValue.length === 1") {{ columnValue[0].name }}
              span(v-else) nenhum
            .loading-field(v-else key="loading-group")

      template(v-slot:detailsBox="{item}")
        Details(:user="userInfoPerId[item.id]" :loading="loadingSelectedUserInfo" @reloadTable="updateTable" @editUser="edit" @reactivateUser="reactivate")

</template>

<script>
import { mapKeys, pickBy, isEmpty } from 'lodash'

import { includesSearch } from 'src/utils'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

import Details from './Details'
import UserDetails from '../details/UserDetails'

export default {
  name: 'UserList',
  props: {
    id: { default: null },
    employeeId: { default: null }
  },
  async created () {
    if (this.id) this.edit(this.id)
    else if (this.employeeId) this.createNewUserFromEmployee(this.employeeId)
  },
  data () {
    return {
      editingId: null,
      showHeader: false,
      selectedUser: {
        index: null,
        item: null
      },
      mode: {
        loaded: [
          {id: false, name: 'somente ativos'},
          {id: true, name: 'desligados'}
        ],
        selected: {id: false, name: 'somente ativos'}
      },
      usuarios: [],
      totalUsers: 0,
      carregandoTabela: false,
      reloadingUserInfo: false,
      userInfoPerId: {},
      table: {
        headerItems: [
          {column: 'usuário', field: 'name', width: '1fr'},
          {column: 'email', field: 'email', width: '1fr'},
          {
            column: this.$wp('companyShortName'),
            field: 'group',
            width: '1fr',
            filterFunction: ({search, item}) => includesSearch(item.group[0].name, search)
          },
          {
            column: 'permissão',
            field: 'roleGroup',
            width: '1fr',
            filterFunction: ({search, item}) => includesSearch(item.roleGroup.name, search)
          }
        ],
        config: {
          perPage: 15,
          startFocusedSearch: 'name',
          defaultSortField: 'name',
          defaultColumnSearch: 'name'
        }
      }
    }
  },
  mounted () {
    setAmplitudeEvent('lista usuarios', {})
  },
  computed: {
    tableData: {
      get () {
        return {
          loading: this.carregandoTabela,
          loaded: this.usuarios
        }
      },
      set ({selected}) {
        this.selectedUser = selected
      }
    }
  },
  methods: {
    async carregarPagina ({perPage, page, orderBy, search, reverse, allSearch}) {
      this.$store.state.common.users.deleted = this.mode.selected.id
      this.carregandoTabela = true
      this.userInfoPerId = {}

      const fields = [
        'id', 'code', 'name', 'email',
        'group', 'role_group', 'current_login_at'
      ]
      const searchType = {
        name: 'name',
        email: 'email',
        group: 'group',
        roleGroup: 'role_group'
      }

      const pesquisas = mapKeys(allSearch, (_, key) => searchType[key])
      const pesquisasAtivas = pickBy(pesquisas, value => value !== '')

      let resultado
      try {
        const params = {
          fields: JSON.stringify(fields),
          fired: 'all',
          'order_by': searchType[orderBy],
          page: page,
          reverse: reverse,
          deleted: this.mode.selected.id,
          'per_page': perPage
        }
        if (!isEmpty(pesquisasAtivas)) {
          params.search = search
          // TODO: CONSERTAR O BACK PARA RECEBER A PESQUISA CORRETAMENTE. PERGUNTAR AO ITALO SILVA
          // params.search = JSON.stringify(pesquisasAtivas)
        }
        resultado = await this.$API.user.get(params)
        if (resultado.status === 204) {
          resultado = {
            body: {
              success: [],
              total: 0,
              totalPages: 0
            }
          }
        }
      } catch (e) {
        console.error(e)
      }

      this.carregandoTabela = false

      this.totalUsers = resultado.body.total

      return {
        items: resultado.body.success,
        totalItems: resultado.body.total,
        totalPages: resultado.body.totalPages
      }
    },
    updateTableAndCloseDetailsBox () {
      this.closeDetailsTable()
      this.$refs.table.resetPagesAndReload()
    },
    updateTable () {
      this.updateTableAndCloseDetailsBox()
    },
    changeMode () {
      setAmplitudeEvent('lista usuarios', {})
      this.updateTable()
    },
    createNewUser () {
      this.editingId = null
      this.showHeader = true
    },
    createNewUserFromEmployee (id) {
      this.editingId = null
      this.employeeId = id
      this.showHeader = true
    },
    edit (id) {
      this.editingId = id
      this.showHeader = true
      this.closeDetailsTable()
    },
    async reactivate (id) {
      try {
        await this.$API.user.update({id: id})
        this.editingId = id
        this.showHeader = true
        this.updateTable()
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível reativar o usuário.')
      }
    },
    closeEdit () {
      this.showHeader = false
      this.closeDetailsTable()
      this.updateTable()
    },
    async genReport () {
      await this.$API.usersReport.get()
      this.$checkUserFiles()
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    },
    async onSelectedUser (user) {
      if (this.userInfoPerId[user.id]) {
        return
      }

      this.$set(this.userInfoPerId, user.id, {...user})

      this.loadingSelectedUserInfo = true

      try {
        const fields = [
          'id', 'name', 'email',
          'role_group', 'group', 'current_login_at'
        ]
        const completeInfo = await this.$API.user.get({
          id: user.id,
          deleted: this.mode.selected.id,
          fields: JSON.stringify(fields)
        })
        if (completeInfo.status === 200) {
          this.$set(this.userInfoPerId, user.id, completeInfo.data.success[0])
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingSelectedUserInfo = false
      }
    }
  },
  components: { Details, UserDetails }
}
</script>

<style scoped lang="scss">
.wrapper-user-list {
  display: grid;
  grid-template-columns: 0.4fr 0.3fr 1fr;
  align-items: baseline;

  .buttons {
    display: grid;
    grid-auto-flow: column;
    grid-column: 3/4;
    grid-gap: 1px;
    justify-self: right;
    margin-bottom: 15px;
  }

  .editor {
    grid-column: 1/4;
    margin-bottom: 30px;
  }

  h2 {
    grid-column: 1/4;
    text-align: center;
  }
  .table {
    grid-column: 1/4;

    .loading-field {
      width: 30%;
      height: 60%;
      background-color: lightgray;
    }
  }
}
</style>
